



























import {
  Component,
  Vue,
  Emit,
  PropSync,
  Watch,
  Prop
} from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component
export default class SetStorePurchaseDisplayDialog extends Vue {
  @PropSync("visible", { type: Boolean, default: false })
  dialogVisible: boolean;
  @Prop({ type: Number, default: 1 }) canViewInventory;
  private isSaveLoading = false;
  form: any = {
    canViewInventory: "1" //"允许门店查询商品库存 1:允许，0:不允许"
  };

  @Watch("visible")
  watchVisibleFn(val) {
    if (val) {
      // 初始化弹窗数据
      this.form.canViewInventory = this.canViewInventory;
    } else {
      let $form: any = this.$refs.form;
      $form && $form.resetFields();
    }
  }
  created() {
    // 获取导出项配置
  }

  submit() {
    let $form: any = this.$refs.form;
    $form.validate(val => {
      if (val) {
        // this.dialogVisible = false;
        this.$emit("submit", this.form.canViewInventory);
      }
    });
  }
}
